import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IMG_BASE_URL } from '../../../../config/Config'

const Home_Sales_Banner = (homeData) => {
  const navigate = useNavigate()
  const gemstoneBanner = homeData?.data?.home_end_sliders
  const category = homeData?.data?.category || [];
  const gemstoneCategory = category?.find(cat => cat?.id === 1);
  const jewelleryCategory = category?.find(cat => cat?.id === 2);

  const navigationHandler = (navigation_type, url) => {
    const routeMap = {
      'book-pooja': '/pooja',
      'astrologer': '/astrologer-list',
      'pandit': '/pandit-list',
      'gemstone': gemstoneCategory?.slug ? `/${gemstoneCategory.slug}` : null,
      'jewellery': jewelleryCategory?.slug ? `/${jewelleryCategory.slug}` : null,
    };

    if (navigation_type === 'url' && url) {
      window.location.href = url
      return;
    }
    else if (routeMap[navigation_type]) {
      navigate(routeMap[navigation_type]);
      return;
    }
    else {
      console.warn(`Unrecognized navigation type: ${navigation_type}`);

      return; // Do nothing if navigation_type is unrecognized
    }
  };


  return (
    <div>
      <section className="w-full gi-banner pt-4 wow fadeInUp" data-wow-duration="2s">
        <div className="w-full cursor-pointer">
          <div onClick={() => navigationHandler(gemstoneBanner?.navigation_type, gemstoneBanner?.url)} >
            <img width="100%" src={`${IMG_BASE_URL}${gemstoneBanner?.image}`} className="w-fill" alt="gemstone_banner_image" />
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home_Sales_Banner